import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Text } from "@cinch-labs/design-system";
import { Wrapper } from "@cinch-nx/shared-ui";
import cx from "classnames";
import TrustpilotLogo from "./assets/trustpilot-logo.svg";
import TrustpilotStars from "./stars/stars";
import styles from "./trustpilot-overview.module.css";
import { sendDigitalDataEvent } from "@cinch-nx/shared-analytics";
import { datadogRum } from "@datadog/browser-rum";
import { Actions, Context } from "../datadog-data";
import { formatNumber } from "@cinch-labs/shared-util";
var TRUSTPILOT_URL = "https://uk.trustpilot.com/review/cinch.co.uk";
var handleTrackEvent = function() {
    datadogRum.addAction(Actions.CLICK_TRUSTPILOT, {
        service: Context.HERO_TRUSTPILOT,
        squad: Context.SQUAD,
        page: "/",
        category: "hero",
        label: "trustpilot"
    });
    sendDigitalDataEvent({
        event: {
            name: "click",
            category: "hero",
            label: "trustpilot"
        }
    });
};
export function TrustpilotOverview(param) {
    var starRating = param.starRating, starRatingLabel = param.starRatingLabel, numberOfReviews = param.numberOfReviews, _className = param.className, className = _className === void 0 ? "" : _className;
    return /*#__PURE__*/ _jsx(Wrapper, {
        "data-testid": "trustpilot-overview-score",
        className: {
            container: className
        },
        children: /*#__PURE__*/ _jsxs("a", {
            href: TRUSTPILOT_URL,
            target: "_blank",
            rel: "noreferrer",
            className: styles.link,
            onClick: function() {
                return handleTrackEvent();
            },
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: styles.trustpilotScoreWrapper,
                    children: [
                        /*#__PURE__*/ _jsx(Text, {
                            className: styles.trustpilotText,
                            children: starRatingLabel
                        }),
                        /*#__PURE__*/ _jsx(TrustpilotStars, {
                            className: styles.trustpilotStars,
                            starRating: starRating,
                            starRatingLabel: starRatingLabel
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: styles.trustpilotScoreWrapper,
                    children: [
                        /*#__PURE__*/ _jsx(Text, {
                            className: cx(styles.numberOfReviews, styles.trustpilotScoreMobileOnly),
                            children: formatNumber(numberOfReviews)
                        }),
                        /*#__PURE__*/ _jsx(Text, {
                            className: cx(styles.reviewsOn, styles.trustpilotScoreMobileOnly),
                            children: "reviews on"
                        }),
                        /*#__PURE__*/ _jsx(TrustpilotLogo, {
                            className: styles.trustpilotLogo
                        })
                    ]
                })
            ]
        })
    });
}
export default TrustpilotOverview;
